<div class="image-preview">
  <div class="image-preview__toolbar">
    <button
      type="button"
      mat-icon-button
      [disabled]="!canZoomOut"
      matTooltip="{{ 'components.imagePreview.zoomOut' | translate }}"
      (click)="zoomOut()"
    >
      <mat-icon>remove</mat-icon>
    </button>

    <button
      type="button"
      class="image-preview__zoom-level"
      matTooltip="{{ 'components.imagePreview.resetZoom' | translate }}"
      (click)="resetZoom()"
    >
      {{ zoomPercent }}%
    </button>

    <button
      type="button"
      mat-icon-button
      [disabled]="!canZoomIn"
      matTooltip="{{ 'components.imagePreview.zoomIn' | translate }}"
      (click)="zoomIn()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <button
    type="button"
    mat-icon-button
    class="image-preview__close"
    matTooltip="{{ 'components.imagePreview.close' | translate }}"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div
    class="image-preview__content"
    [class.image-preview__content--zoomed]="isZoomed"
    (click)="close()"
    (wheel)="onWheel($event)"
    (mousedown)="onPanStart($event)"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd($event)"
    (touchcancel)="onTouchEnd($event)"
  >
    <img
      #imageEl
      [src]="data.url"
      alt=""
      draggable="false"
      [style.transform]="imageTransform"
      [class.image-preview__image--zoomed]="isZoomed"
      (click)="$event.stopPropagation()"
      (dblclick)="$event.stopPropagation(); onDoubleClick()"
    />
  </div>
</div>
